// extracted by mini-css-extract-plugin
export var upcoming = "upcoming-module--upcoming--O8teG";
export var leftSide = "upcoming-module--leftSide--GqZ4b";
export var rightSide = "upcoming-module--rightSide--3jjB3";
export var titleContainer = "upcoming-module--titleContainer--gsplW";
export var description = "upcoming-module--description--2O4Xa";
export var upcomingMobile = "upcoming-module--upcomingMobile--32X_A";
export var leftSideMobile = "upcoming-module--leftSideMobile--GLQUz";
export var leftSideMobile2 = "upcoming-module--leftSideMobile2--2wDEK";
export var rightSideMobile = "upcoming-module--rightSideMobile--ARgOY";
export var rightSideMobile2 = "upcoming-module--rightSideMobile2--3X7xf";